

































import { Component, Prop, Vue } from "vue-property-decorator";
import { Product } from "@/interfaces/product";
import GridColorChipComponent from "@/components/_shared/grid-components/grid-cells/grid-color-chip-component.vue";

const EMPTY = "-";

@Component({
  name: "product-card",
  components: { GridColorChipComponent },
})
export default class ProductCard extends Vue {
  @Prop() product: Product;

  get code(): string {
    return this.product?.code ? this.product.code.toUpperCase() : EMPTY;
  }

  get label(): string {
    return this.product?.label ?? "";
  }

  get color(): string | null {
    return this.product?.attributes?.color ?? null;
  }

  get pcbLabel(): string {
    const pcb = this.product?.attributes?.pcb;
    if (pcb == null || isNaN(pcb)) {
      return EMPTY;
    }
    return `${pcb} ${this.$tc("product.card.bottles", pcb)}`;
  }

  get capacityLabel(): string {
    const capacity = this.product?.attributes?.capacity;
    return capacity == null || isNaN(capacity) ? EMPTY : `${capacity}cl`;
  }

  get conditioningLabel(): string {
    return this.product?.attributes?.conditionning ?? EMPTY;
  }

  /**
   * "Famille / Sous-famille" : la famille parente porte la famille, la famille du produit
   * porte la sous-famille (même convention que la grille produit).
   */
  get familyLabel(): string {
    const subFamily = this.product?.family;
    if (!subFamily) {
      return EMPTY;
    }
    const family = subFamily.family;
    return family?.name ? `${family.name} / ${subFamily.name}` : (subFamily.name ?? EMPTY);
  }
}
